import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CarsErrorHandlingModule} from 'app/error-handling/cars-error-handling.module';
import {LinkManagerComponent} from './link-manager.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    CarsErrorHandlingModule,
    MatIconModule,
    MatTableModule,
    MatRadioModule,
    MatInputModule,
    MatProgressBarModule,
    MatRadioModule,
    FormsModule,
  ],
  declarations: [LinkManagerComponent],
  exports: [LinkManagerComponent],
})
export class LinkManagerModule {}
